import { apiGet, apiPost, apiPut, apiDelete, ApiError } from "./client";

export interface Organization {
  id: number;
  name: string;
  address: string;
  city: string;
  post_code: string;
  country: string;
  billing_address: string;
  billing_city: string;
  billing_post_code: string;
  billing_country: string;
  licenses: number;
}

export interface OrganizationUser {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  role_slug: string;
  last_connection: string;
  commercial_plan_name: string;
  commercial_plan_id: number;
}

export function getOrganization(): Promise<Organization> {
  return apiGet<Organization>("/organization");
}

export function getUsersOrganization(): Promise<OrganizationUser[]> {
  return apiGet<OrganizationUser[]>("/organization/user");
}

export function editOrganization(data: {
  name: string;
  address: string;
  city: string;
  post_code: string;
  country: string;
  billing_address: string;
  billing_city: string;
  billing_post_code: string;
  billing_country: string;
}): Promise<void> {
  return apiPut<void>("/organization", data);
}

export function addUser(email: string): Promise<void> {
  return apiPost<void>("/organization/user", { email });
}

export function editRoleUser(
  userId: number,
  roleSlug: string,
): Promise<void> {
  return apiPut<void>(`/organization/user/${userId}/role`, {
    role_slug: roleSlug,
  });
}

export function deleteUser(userId: number): Promise<void> {
  return apiDelete<void>(`/organization/user/${userId}`);
}

export { ApiError };
